export type ActivityId = keyof typeof GAME_IDS;

export const GAME_IDS = {
  GENESIS_SOL: 'Genesis Sol',
  GENESIS_KANA: 'Genesis Kana',
  GENESIS_KANALOVESTOPLAY: 'Genesis Kana Loves to Play',
  GENESIS_KANAMOVEAROUND: 'Genesis Kana Move Around',
  GENESIS_KANARELEASE: 'Genesis Kana Release',
  GENESIS_KANARECONNECT: 'Genesis Kana Reconnect',
  GENESIS_KANAGOTOSOMA: 'Genesis Kana Go to Soma',
  GENESIS_SMALLSOLTOHAND: 'Genesis Small Sol to Hand',
  GENESIS_SOLRELEASEDABSORBED: 'Genesis Sol Released Absorbed',
  GENESIS_SOLPRACTICE: 'Genesis Sol Practice',
  GENESIS_SOLCREATEFISH: 'Genesis Sol Create Fish',
  GENESIS_SOLFLICKAWAY: 'Genesis Sol Flick Away',
  GENESIS_SMALLSOLTOHANDREMAINING: 'Genesis Small Sol to Hand Remaining',
  GENESIS_FISHCONTROL: 'Genesis Fish Control',
  GENESIS_FISHEXPLORESOMA: 'Genesis Fish Explore Soma',
  GENESIS_FISHEXPLOREMOVEMENT: 'Genesis Fish Explore Movement',
  GENESIS_FISHPOSTEXPLOREMOVEMENT: 'Genesis Fish Post Explore Movement',
  GENESIS_FISHRECONNECT: 'Genesis Fish Reconnect',
  GENESIS_FISHGOTOPROTECT: 'Genesis Fish Go to Protect',
  GENESIS_FISHREEFDESTRUCTION: 'Genesis Fish Reef Destruction',
  GENESIS_FISHFIRSTBATTLE: 'Genesis Fish First Battle',
  GENESIS_FISHRELEASECONNECT: 'Genesis Fish Release Connect',
  GENESIS_SOLCREATECORAL: 'Genesis Sol Create Coral',
  GENESIS_SOLREMAINING: 'Genesis Sol Remaining',
  GENESIS_FISHGOTOPLAY: 'Genesis Fish Go to Play',
  GENESIS_FISHGOTOGAME: 'Genesis Fish Go to Game',
  GENESIS_FIRSTGAME: 'Genesis First Game',
  GENESIS_SFISHBALLBUSTER: 'Genesis S Fish Ball Buster',
  GENESIS_SECONDGAME: 'Genesis Second Game',
  GENESIS_OCTOGRAVITYBALLS: 'Genesis Octo Gravity Balls',
  GENESIS_RETURNTOSOMA: 'Genesis Return to Soma',
  GENESIS_CREATEANOTHERCORALANDFISH: 'Genesis Create Another Coral and Fish',
  GENESIS_BUMPANOTHERSFISH: 'Genesis Bump Another\'s Fish',
  GENESIS_SFISHFLOCKING_BURST1: 'Genesis S Fish Flocking Burst 1',
  GENESIS_SFISHFLOCKING_GRASP1: 'Genesis S Fish Flocking Grasp 1',
  GENESIS_SFISHFLOCKING_BURST2: 'Genesis S Fish Flocking Burst 2',
  GENESIS_SFISHFLOCKING_GRASP2: 'Genesis S Fish Flocking Grasp 2',
  GENESIS_SFISHFLOCKING_BURSTANDGRASP: 'Genesis S Fish Flocking Burst and Grasp',
  GENESIS_FINALWISDOM: 'Genesis Final Wisdom',
  GENESIS_GOANDPLAY: 'Genesis Go and Play',

  FREEPLAY_NOSPECIAL: 'Freeplay No Special',
  FREEPLAY_OCTO_SOMA: 'Freeplay Octo Soma',
  FREEPLAY_ALGAE: 'Freeplay Algae',
  FREEPLAY_ACROBAT: 'Freeplay Acrobat',
  FREEPLAY_WATCHANDPLAY: 'Freeplay Watch and Play',
  FREEPLAY_OCTO_WATCHANDPLAY: 'Freeplay Octo Watch and Play',
  FREEPLAY_FACEMIMIC: 'Freeplay Face Mimic',
  FREEPLAY_FOLLOWTHELEADER: 'Freeplay Follow the Leader',
  FREEPLAY_PUREIMAGINATION: 'Freeplay Pure Imagination',
  FREEPLAY_TRANSITIONOUT: 'Freeplay Transition Out',
  FREEPLAY_FINALE: 'Freeplay Finale',

  GAMEPLAY_NOSPECIAL: 'Gameplay No Special',
  GAMEPLAY_OCTORUN: 'Gameplay Octo Run',
  GAMEPLAY_SFISHGOBALLS: 'Small Fish Go',
  GAMEPLAY_FISHRUN: 'Gameplay Fish Run',
  GAMEPLAY_SUPERFISHRUN: 'Gameplay Super Fish Run',
  GAMEPLAY_FISHGRAVITYBALLS: 'Fish Gravity Ball',
  GAMEPLAY_SFISHBALLBUSTER: 'Small Fish BoomP',
  GAMEPLAY_FISHBALLBUSTER: 'Fish BoomP',
  GAMEPLAY_SUPERSFISHBALLBUSTER: 'Gameplay Super S Fish Ball Buster',
  GAMEPLAY_SUPERFISHBALLBUSTER: 'Gameplay Super Fish Ball Buster',
  GAMEPLAY_OCTOGRAVITYBALLS: 'Octo Gravity Ball',
  GAMEPLAY_TAG: 'Gameplay Tag',
  GAMEPLAY_BERZERKBALL: 'Scoot',
  GAMEPLAY_SUPERBERZERKBALL: 'Gameplay Super Berzerk Ball',
  GAMEPLAY_TRANSITIONOUT: 'Gameplay Transition Out',
  GAMEPLAY_OCTOFETCH: 'Gameplay Octo Fetch',
  GAMEPLAY_POWERUPINTRODUCTION: 'Gameplay Power-Up Introduction',
  GAMEPLAY_FACEMIMIC: 'Gameplay Face Mimic',
  GAMEPLAY_OCTOINTERACT: 'Gameplay Octo Interact',
  GAMEPLAY_SPARKLEMAGIC: 'Gameplay Sparkle Magic',
  GAMEPLAY_SFISHSHORTSPAR: 'Small Fish Spar',
  GAMEPLAY_FISHSHORTSPAR: 'Gameplay Fish Short Spar',

  OMINOUS_POWERUPINTRODUCTION: 'Ominous Power-Up Introduction',
  OMINOUS_PUREIMAGINATION: 'Ominous Pure Imagination',
  OMINOUS_GAMEOVER_PURGATORY: 'Ominous Game Over Purgatory',
  OMINOUS_BATTLE: 'Ominous Battle',
  OMINOUS_NOSPECIAL: 'Ominous No Special',
  OMINOUS_SHARKZONE: 'Ominous Shark Zone',
  OMINOUS_SHARKPREPARE: 'Ominous Shark Prepare',
  OMINOUS_SHARKBOSSBATTLES: 'Ominous Shark Boss Battles',
  OMINOUS_TRANSITIONOUT: 'Ominous Transition Out',
  OMINOUS_PICKUPPOWERUPS: 'Ominous Pick Up Power-Ups',
  '': ''
} as const;